import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
const RECIPIENTS = ['michealstufflebeam@outlook.com', 'lawfirmcalifornia@outlook.com'];
export function ContactSection() {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = `Consultation Request from ${form.firstName} ${form.lastName}`.trim();
    const body = [`Name: ${form.firstName} ${form.lastName}`, `Email: ${form.email}`, `Phone: ${form.phone}`, '', 'Message:', form.message].join('\n');
    const mailto = `mailto:${RECIPIENTS.join(',')}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  };
  return <section id="contact" className="py-16 md:py-24 bg-[#1a1a1a] text-white relative overflow-hidden" data-id="element-31">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#7c0a0a] opacity-10 skew-x-12 translate-x-32" data-id="element-32" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10" data-id="element-33">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16" data-id="element-34">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-35">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold mb-6" data-id="element-36">
              Ready to Discuss Your Case?
            </h2>
            <p className="text-gray-300 text-base sm:text-lg mb-10" data-id="element-37">
              Time is often critical in legal matters. Contact our office today
              to schedule a confidential consultation with our experienced legal
              team.
            </p>

            <div className="space-y-8" data-id="element-38">
              <div data-id="element-39">
                <h3 className="text-[#c9a35a] font-semibold uppercase tracking-wider mb-2" data-id="element-40">
                  Call Us 24/7
                </h3>
                <a href="tel:469-713-6764" className="font-serif text-2xl sm:text-3xl font-bold hover:text-[#c9a35a] transition-colors" data-id="element-41">
                  469-713-6764
                </a>
              </div>

              <div data-id="element-42">
                <h3 className="text-[#c9a35a] font-semibold uppercase tracking-wider mb-2" data-id="element-43">
                  Office Location
                </h3>
                <p className="text-xl" data-id="element-44">
                  310 4th St
                  <br data-id="element-45" />
                  Hermosa Beach, CA 90254
                </p>
              </div>

              <div data-id="element-46">
                <h3 className="text-[#c9a35a] font-semibold uppercase tracking-wider mb-2" data-id="element-47">
                  Email Us
                </h3>
                <div className="flex flex-col gap-1" data-id="element-48">
                  <a href="mailto:michealstufflebeam@outlook.com" className="text-lg sm:text-xl hover:text-[#c9a35a] transition-colors break-words" data-id="element-49">
                    michealstufflebeam@outlook.com
                  </a>
                  <a href="mailto:lawfirmcalifornia@outlook.com" className="text-lg sm:text-xl hover:text-[#c9a35a] transition-colors break-words" data-id="element-50">
                    lawfirmcalifornia@outlook.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-6 sm:p-8 md:p-10 shadow-2xl" data-id="element-51">
            <h3 className="font-serif text-2xl sm:text-3xl text-[#1a1a1a] font-bold mb-6" data-id="element-52">
              Request a Consultation
            </h3>
            <form className="space-y-6" onSubmit={handleSubmit} data-id="element-53">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-54">
                <div data-id="element-55">
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-56">
                    First Name
                  </label>
                  <input type="text" id="firstName" value={form.firstName} onChange={handleChange} required className="w-full border-b-2 border-gray-300 py-2 text-gray-900 focus:outline-none focus:border-[#7c0a0a] transition-colors bg-transparent" placeholder="John" data-id="element-57" />
                </div>
                <div data-id="element-58">
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-59">
                    Last Name
                  </label>
                  <input type="text" id="lastName" value={form.lastName} onChange={handleChange} className="w-full border-b-2 border-gray-300 py-2 text-gray-900 focus:outline-none focus:border-[#7c0a0a] transition-colors bg-transparent" placeholder="Doe" data-id="element-60" />
                </div>
              </div>

              <div data-id="element-61">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-62">
                  Email Address
                </label>
                <input type="email" id="email" value={form.email} onChange={handleChange} required className="w-full border-b-2 border-gray-300 py-2 text-gray-900 focus:outline-none focus:border-[#7c0a0a] transition-colors bg-transparent" placeholder="john@example.com" data-id="element-63" />
              </div>

              <div data-id="element-64">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-65">
                  Phone Number
                </label>
                <input type="tel" id="phone" value={form.phone} onChange={handleChange} className="w-full border-b-2 border-gray-300 py-2 text-gray-900 focus:outline-none focus:border-[#7c0a0a] transition-colors bg-transparent" placeholder="(949) 555-0123" data-id="element-66" />
              </div>

              <div data-id="element-67">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-68">
                  How can we help you?
                </label>
                <textarea id="message" rows={4} value={form.message} onChange={handleChange} required className="w-full border-2 border-gray-300 p-3 text-gray-900 focus:outline-none focus:border-[#7c0a0a] transition-colors bg-transparent mt-1 resize-none" placeholder="Briefly describe your legal issue..." data-id="element-69"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#7c0a0a] hover:bg-[#5a0707] text-white font-serif font-bold text-lg py-4 transition-colors" data-id="element-70">
                Submit Request
              </button>
              <p className="text-xs text-gray-500 text-center mt-4" data-id="element-71">
                Disclaimer: Submitting this form does not create an
                attorney-client relationship.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}